import { JobStatusEnum } from '../../models/jobStatusEnum';
import { PoolerUser } from '../../models/user';

export function getPoolerArchivedTabJobsQuery(_user: PoolerUser): object {
  return { status: JobStatusEnum.ARCHIVED };
}
